export const NEWS_DETAILS_REQUEST = 'NEWS_DETAILS_REQUEST';
export const NEWS_DETAILS_SUCCESS = 'NEWS_DETAILS_SUCCESS';
export const NEWS_DETAILS_FAILURE = 'NEWS_DETAILS_FAILURE';

export const NEWS_LIST_REQUEST = 'NEWS_LIST_REQUEST';
export const NEWS_LIST_SUCCESS = 'NEWS_LIST_SUCCESS';
export const NEWS_LIST_FAILURE = 'NEWS_LIST_FAILURE';



// WEBPACK FOOTER //
// ./src/features/News/types.js